/**
 * The name of the bundled sound file which will be played when a
 * participant enters lobby.
 */
export const KNOCKING_PARTICIPANT_FILE = 'knock.mp3';
